module.exports = __webpack_public_path__ + "static/media/InternalMedicineImage2@3x.876ca250.png";